import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface UploadErrorBlockProps {
  error: string;
  errorFiles?: File[];
}

export const UploadErrorBlock: FC<UploadErrorBlockProps> = ({
  error,
  errorFiles = []
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm flex flex-col gap-4">
      {error}
      <div className="flex flex-col">
        <p className="font-semibold text-red-600 text-base">
          {t('dashboard.invalidFiles')}
        </p>
        {errorFiles.length > 0 && (
          <ul className="max-h-[100px] overflow-y-auto mt-2 list-disc list-inside">
            {errorFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
